import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceTypeService } from '@services/device-type.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  standalone: false,
})
export class PopupComponent implements OnInit {
  alertType: string = '';
  @Input() title: string = '';
  @Input() icon: string = 'plug';
  @Input() messageAlert: string = '';
  @Input() secundaryMessageAlert: string = '';
  @Input() closeText: string = '';
  @Input() actionText: string = '';
  @Input() cancelText: string = '';
  @Input() showActionBtn: boolean = false;
  @Input() showCancelBtn: boolean = false;
  @Input() centered: boolean = false;
  @Input() showCrossBtn: boolean = false;
  @Input() showActionIcon: boolean = true;
  @Input() topPosition: number = 0;
  @Input() leftPosition: number = 0;
  @Input() modalWidth!: number;
  @ViewChild('positionModal', { static: false }) positionModal!: ElementRef;

  constructor(
    protected activeModal: NgbActiveModal,
    public deviceType: DeviceTypeService,
  ) {}

  close() {
    this.activeModal.close('doAction');
  }

  dismiss() {
    this.activeModal.close('close');
  }

  cancel() {
    this.activeModal.close('cancel');
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.centered) this.setModalCentered();
    else this.checkIfOutsideScreen();
  }

  checkIfOutsideScreen(): void {
    const element = this.positionModal.nativeElement;
    const rect = element.getBoundingClientRect();
    const pixelsOutsideBottom = Math.max(0, rect.bottom - window.innerHeight);
    if (pixelsOutsideBottom > 0) this.topPosition = this.topPosition - (pixelsOutsideBottom + 10);
  }

  setModalCentered() {
    const rect = this.positionModal.nativeElement.getBoundingClientRect();
    this.leftPosition = window.innerWidth / 2 - rect.width / 2;
    if (this.leftPosition + rect.right >= window.innerWidth) {
      this.leftPosition = 0;
      this.modalWidth = window.innerWidth - window.innerWidth / 10;
    }
    this.topPosition = window.innerHeight / 2 - rect.height / 2;
    const element = this.positionModal.nativeElement;
    element.style.top = `${this.topPosition}px`;
    element.style.left = `${this.leftPosition}px`;
  }
}
